import React, { useState } from 'react';

const StarRating = ({ totalStars = 5, onRate, initrating, readonly }) => {
    const [rating, setRating] = useState(0);
    const [hoveredStar, setHoveredStar] = useState(initrating);

    const handleClick = (star) => {
        setRating(star);
        if (onRate) onRate(star);
    };

    return (
        <div className="starcontainer">
            {[...Array(totalStars)].map((_, index) => {
                const starValue = index + 1;
                const isFilled = starValue <= (hoveredStar || rating);

                return readonly ? (
                    <span
                        key={starValue}
                        className={` withoutPointer ${isFilled ? 'filled' : ''}`}
                    >
                        ★
                    </span>
                ) : (
                    <span
                        key={starValue}
                        className={`star ${isFilled ? 'filled' : ''}`}
                        onClick={() => handleClick(starValue)}
                        onMouseEnter={() => setHoveredStar(starValue)}
                        onMouseLeave={() => setHoveredStar(0)}
                    >
                        ★
                    </span>
                );
            })}
        </div>
    );
};



export default StarRating;